
import { Attr } from "@/lib/model/exambuilder/exam-component/application-rule";
import { Component, Vue } from "vue-property-decorator";
import RuleFormItem from "./rule-form-item.vue";
import { cloneDeep } from "lodash-es";

const statusText: {
  [key: number]: string;
} = {
  1: "通过",
  2: "待定",
  3: "拒绝"
};

@Component({
  name: "RuleForm",
  components: { RuleFormItem }
})
export default class RuleForm extends Vue {
  private visible = false;
  private title = "";
  private idx: number | undefined = undefined;
  private status = 0;
  private baseData: Attr = {
    name: "",
    remark: "",
    matchNode: {
      subList: [{ detail: {} }],
      mergeType: "OR"
    }
  };

  private formData = cloneDeep(this.baseData);

  rules = {
    name: [{ required: true, message: "请输入条件组名称", trigger: "blur" }]
  };

  add(status: number, params?: Attr) {
    this.status = status;
    this.idx = undefined;
    this.title = `添加${statusText[status]}条件`;
    if (params) {
      this.formData = cloneDeep(params);
    }
    this.visible = true;
  }

  edit(params: Attr, status: number, idx: number) {
    this.idx = idx;
    this.status = status;
    this.title = `编辑${statusText[status]}条件`;
    this.formData = cloneDeep(params);
    this.visible = true;
  }

  handleAdd() {
    this.formData.matchNode.subList?.push({
      mergeType: "AND",
      subList: [{ detail: {} }]
    });
  }

  handleAddOr() {
    this.formData.matchNode.subList?.push({
      detail: {}
    });
  }

  private reset() {
    this.formData = cloneDeep(this.baseData);
  }

  private beforeClose() {
    this.reset();
    this.$nextTick(() => {
      (this.$refs.form as any).clearValidate();
    });
    this.visible = false;
  }

  private handleSubmit() {
    if (!this.formData.matchNode.subList?.length) {
      this.$message.error("请添加命中条件");
      return;
    }
    (this.$refs.form as any).validate((valid: boolean) => {
      if (!valid) return false;
      this.$emit("success", this.formData, this.status, this.idx);
      this.beforeClose();
    });
  }

  private handleMouseEnter(e: MouseEvent) {
    if (this.formData.matchNode.subList!.length <= 1) return;
    (e.target as HTMLElement).classList.add("err-active");
  }

  private handleMouseLeave(e: MouseEvent) {
    (e.target as HTMLElement).classList.remove("err-active");
  }
}
